import { render, staticRenderFns } from "./DaysLeft.vue?vue&type=template&id=20ec3f47&scoped=true"
import script from "./DaysLeft.vue?vue&type=script&lang=js"
export * from "./DaysLeft.vue?vue&type=script&lang=js"
import style0 from "./DaysLeft.vue?vue&type=style&index=0&id=20ec3f47&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ec3f47",
  null
  
)

export default component.exports